/* @flow */
import * as React from 'react';
import type { StatelessFunctionalComponent } from 'react';
import { observer } from 'mobx-react';
import VirtualizedSelect from 'react-virtualized-select';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import FormHelperText from '@material-ui/core/FormHelperText';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import electroSelectStyles from '../ElectroSelect/ElectroSelect.module.scss';

/**
 * Basic select for when you do not need autocomplete or an 'Other' field
 * TODO: Replace FormHelperText with VirtualizedSelect's native helperText (if possible)
 *
 * @component ElectroSelectBasic
 * @prop { Object } field
 * @return { React.StatelessFunctionalComponent }
 */
const ElectroSelectBasic: StatelessFunctionalComponent<{ field: any, style: any }> = ({
  field,
  style,
}) => {
  return (
    <React.Fragment>
      <VirtualizedSelect
        style={style}
        {...field.bind()}
        searchable={false}
        clearable={false}
        options={field.extra && field.extra.options ? field.extra.options : field.options}
        // className={styles['virtualized-select']}
        onChange={(value: Object) => {
          field.set('value', value ? value.id : '');
        }}
        helperText="Helper text where are you?"
        placeholder={`${field.label || 'Select...'} ${
          field.rules ? field.rules.includes('required') && '*' : ''
        }`}
        value={field.value && field.value.id ? field.value.id : field.value}
        name={field.name}
        labelKey="name"
        valueKey="id"
      />
      {field.value === '' && field.error && (
        //field.showError &&
        <FormHelperText error={true}>{field.error}</FormHelperText>
      )}
    </React.Fragment>
  );
};

export default observer(ElectroSelectBasic);
